// extracted by mini-css-extract-plugin
export default {"main":"PictureGallery_main__YLEXK","poster":"PictureGallery_poster__pDoFY","controls":"PictureGallery_controls__xP6Xf","gallery":"PictureGallery_gallery__EkcVe"};